import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';
import { Icon } from '../Icon';

interface ButtonProps {
  $isDragActive?: boolean;
  $hasError?: boolean;
  $inputHeight?: boolean;
}

export const Button = styled(ButtonReset)<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: ${size(0.5)};
  padding: ${size(1.5)};
  border: 1px dashed var(--c-border-alt);
  border-radius: var(--border-radius);
  font-size: ${(props) => props.theme.font.size.small};
  font-weight: var(--font-weight-bold);
  color: var(--c-link);
  text-decoration: none;
  user-select: none;
  cursor: pointer;

  &:enabled {
    &:hover {
      text-decoration: underline;
    }
  }

  &[disabled] {
    opacity: 0.37;
    cursor: not-allowed;
  }

  ${Icon} {
    font-size: ${(props) => props.theme.font.size.xxlarge};
    margin: ${size(-1.5)} 0;
  }

  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: var(--c-input-error-border);
      color: var(--c-input-error-text);
    `}

    ${({ $inputHeight }) =>
      $inputHeight &&
      css`
        height: ${(props) => props.theme.distances.inputHeight};
    `}

  ${({ $isDragActive }) =>
    $isDragActive &&
    css`
      background-color: var(--c-upload-button-bg);
      animation: background-opacity 2s infinite linear;

      @keyframes background-opacity {
        0% {
          background-color: var(--c-upload-button-bg)
        }
        50% {
          background-color: var(--c-upload-button-bg-last)
        }
        100% {
          background-color: var(--c-upload-button-bg)
        }
      }
    `}
`;
